<script setup lang="ts">

import StfRow from '@/ui/columns/StfRow.vue';
</script>

<template>
    <StfRow>
        <StfCol col="12">
            <slot name="left"/>
        </StfCol>
        <StfCol col="12" class="pt-3">
            <StfRow style="background-color: #f2f2f2;margin-left: -10px;margin-right: -10px;" class="pb-3">
                <StfCol col="12" style="padding-left: 10px;padding-right: 10px;">
                    <slot name="right"/>
                </StfCol>
            </StfRow>
        </StfCol>
    </StfRow>
</template>
